export const astrologyReviews = [
  {
    id: 1,
    name: '임지현',
    role: '에디터 · 31세',
    date: '2026년 2월',
    image: 'https://public.readdy.ai/ai/img_res/4db8e89c8fe0b6127898825aa2372027.jpg',
    content: '점성술 탄생 차트에서 태양궁이 게자리, 달자리가 전갈자리로 나왔을 때 소름이 돋았어요. 평소에 제가 왜 그렇게 감정을 숨기는지 "달이 전갈자리에 있어서 감정을 깊이 간직하는 성향"이라는 분석이 딱 들어맞았거든요. 별자리가 단순 띠운세가 아니라는 걸 처음 느꼈습니다.',
    rating: 5,
    tag: '점성술 리딩',
    tagColor: 'text-purple-400 bg-purple-500/10 border-purple-500/25',
    highlight: '달자리 분석이 내면을 정확히 꿰뚫음',
  },
  {
    id: 2,
    name: '오승현',
    role: '개발자 · 34세',
    date: '2025년 12월',
    image: 'https://readdy.ai/api/search-image?query=korean%20man%20mid%2030s%20intellectual%20friendly%20smile%20wearing%20casual%20dark%20shirt%20clean%20modern%20look%20soft%20studio%20background%20natural%20lighting%20portrait%20photography&width=300&height=300&seq=astro-review-2&orientation=squarish',
    content: '이직을 결정비서에게 물었는데, 직장·커리어 분석에서 "정관(正官)이 강한 시기라 명예와 안정을 동시에 얻을 수 있다"고 나왔어요. 반신반의하다가 3개월 뒤 대기업 이직 성공했습니다. 타이밍 분석이 이렇게 구체적인 줄 몰랐어요.',
    rating: 5,
    tag: '결정 비서',
    tagColor: 'text-amber-400 bg-amber-500/10 border-amber-500/25',
    highlight: '이직 타이밍 3개월 뒤 성공',
  },
  {
    id: 3,
    name: '윤서아',
    role: '대학원생 · 26세',
    date: '2026년 1월',
    image: 'https://readdy.ai/api/search-image?query=young%20korean%20woman%20mid%2020s%20fresh%20bright%20smile%20wearing%20simple%20white%20blouse%20straight%20black%20hair%20minimal%20accessories%20clean%20academic%20look%20soft%20background%20portrait%20photography&width=300&height=300&seq=astro-review-3&orientation=squarish',
    content: '상승궁이 사자자리라는 분석을 보고 왜 사람들이 저를 처음 볼 때 당당해 보인다고 하는지 이해했어요. 실제 내면은 물고기자리처럼 예민한데 겉보기엔 그렇지 않다는 것도요. 행성 배치까지 보여주니까 그냥 별자리 앱이랑 차원이 달랐습니다.',
    rating: 5,
    tag: '점성술 리딩',
    tagColor: 'text-purple-400 bg-purple-500/10 border-purple-500/25',
    highlight: '상승궁 분석으로 자기 이해',
  },
  {
    id: 4,
    name: '강태준',
    role: '소상공인 · 40세',
    date: '2025년 11월',
    image: 'https://readdy.ai/api/search-image?query=korean%20businessman%20early%2040s%20confident%20relaxed%20smile%20wearing%20navy%20casual%20jacket%20clean%20professional%20look%20light%20neutral%20background%20portrait%20photography&width=300&height=300&seq=astro-review-4&orientation=squarish',
    content: '카페 2호점을 낼 결심을 못하고 있을 때 결정비서에게 창업·투자 상담을 했는데, "편재(偏財) 기운이 내년 상반기에 집중된다"는 구체적인 조언을 받았어요. 올해 3월에 오픈했고 예상보다 훨씬 빠르게 손익분기점을 넘겼습니다.',
    rating: 5,
    tag: '결정 비서',
    tagColor: 'text-amber-400 bg-amber-500/10 border-amber-500/25',
    highlight: '창업 타이밍으로 빠른 손익분기 돌파',
  },
  {
    id: 5,
    name: '박나연',
    role: '간호사 · 28세',
    date: '2026년 2월',
    image: 'https://readdy.ai/api/search-image?query=young%20korean%20woman%20late%2020s%20gentle%20kind%20expression%20wearing%20light%20blue%20top%20medium%20length%20hair%20natural%20fresh%20look%20indoor%20warm%20soft%20light%20portrait%20photography&width=300&height=300&seq=astro-review-5&orientation=squarish',
    content: '처녀자리 태양궁에 수성이 처녀자리에 있어서 "분석적이고 완벽주의 성향이 두드러진다"는 해석이 너무 저 같아서 웃었어요. 행성 배치가 이렇게 자세히 나오는 서비스는 처음이에요. 무료 별자리 앱들이랑 비교가 안 됩니다.',
    rating: 4,
    tag: '점성술 리딩',
    tagColor: 'text-purple-400 bg-purple-500/10 border-purple-500/25',
    highlight: '행성 배치까지 상세 분석',
  },
  {
    id: 6,
    name: '김도현',
    role: '직장인 · 32세',
    date: '2026년 1월',
    image: 'https://readdy.ai/api/search-image?query=korean%20man%20early%2030s%20smart%20casual%20smile%20wearing%20grey%20sweater%20modern%20hairstyle%20clean%20background%20soft%20studio%20light%20portrait%20photography&width=300&height=300&seq=astro-review-6&orientation=squarish',
    content: '결혼 결정을 앞두고 결정비서와 여러 번 상담했어요. 단순히 "좋다 나쁘다"가 아니라 "정관이 활성화된 가을이 인연 확정에 가장 좋은 구간"이라고 구체적인 근거를 줘서 신뢰가 갔어요. 9월에 프로포즈했고 지금은 결혼 준비 중입니다.',
    rating: 5,
    tag: '결정 비서',
    tagColor: 'text-amber-400 bg-amber-500/10 border-amber-500/25',
    highlight: '결혼 결정 타이밍 구체적 조언',
  },
];
